import { useState, useEffect } from "react";

export function useHandymanOnboardingStatus() {
  const [onboardingCompleted, setOnboardingCompleted] = useState(false);

  useEffect(() => {
    const sync = () => setOnboardingCompleted(localStorage.getItem("onboardingCompleted") === "true");
    sync();
    window.addEventListener("onboarding-updated", sync);
    window.addEventListener("storage", sync);
    return () => {
      window.removeEventListener("onboarding-updated", sync);
      window.removeEventListener("storage", sync);
    };
  }, []);

  return onboardingCompleted;
}
